import {WebGLBrandedDivider} from '@github-ui/brand-webgl'
import {Button, Hero} from '@primer/react-brand'
import {useEffect, useState} from 'react'
import {clsx} from 'clsx'

import {InstallerActionMenu, type InstallerItem} from './../InstallerActionMenu/InstallerActionMenu'

import Styles from './CtaBanner.module.css'

export interface CtaBannerProps {
  label: string
  heading: string
  body: string
  cta1: {
    items: InstallerItem[]
  }
  cta2: {
    label: string
    href: string
  }
}

export const CtaBanner = ({label, heading, body, cta1, cta2}: CtaBannerProps) => {
  const [isMounted, setIsMounted] = useState<boolean>(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsMounted(true)
  }, [])

  return (
    <div className={clsx(Styles['CtaBanner'], !isMounted && Styles['CtaBanner--hidden'])}>
      <Hero
        className={Styles['CtaBanner__hero']}
        variant="gridline"
        align="center"
        enableAnimation
        aria-label={heading}
        aria-labelledby={undefined}
        trailingComponent={() => (
          <div className={Styles['CtaBanner__ctas']}>
            <InstallerActionMenu items={cta1.items} />

            <Button as="a" href={cta2.href} variant="subtle" hasArrow={false}>
              {cta2.label}
            </Button>
          </div>
        )}
      >
        <Hero.Label>{label}</Hero.Label>
        <Hero.Heading {...({as: 'h2'} as Record<string, unknown>)}>{heading}</Hero.Heading>

        <Hero.Description>{body}</Hero.Description>
      </Hero>

      <WebGLBrandedDivider
        className={Styles['CtaBanner__brandedDivider']}
        params={{
          character: 'invertocat',
          layout: 1,
        }}
      />
    </div>
  )
}
